import type { QueryKey } from '@/queries/core/types'

export const STYLE_SPACE_KEY_HEAD = 'style-space' as const

export const styleSpaceKeys = {
  wardrobe: () => [STYLE_SPACE_KEY_HEAD, 'wardrobe'] as const,
  wardrobeItem: (id: number) => [STYLE_SPACE_KEY_HEAD, 'wardrobe-item', id] as const,
  outfits: () => [STYLE_SPACE_KEY_HEAD, 'outfits'] as const,
  capsules: () => [STYLE_SPACE_KEY_HEAD, 'capsules'] as const,
  capsule: (id: number) => [STYLE_SPACE_KEY_HEAD, 'capsule', id] as const,
  availableItems: (outfitId: number, capsuleIds: readonly number[]) =>
    [STYLE_SPACE_KEY_HEAD, 'available-items', outfitId, capsuleIds.join(',')] as const,
  references: () => [STYLE_SPACE_KEY_HEAD, 'references'] as const,
  sizeSystems: (subcategoryId: number) =>
    [STYLE_SPACE_KEY_HEAD, 'size-systems', subcategoryId] as const,
  surveyConfig: () => [STYLE_SPACE_KEY_HEAD, 'survey-config'] as const,
}

type StyleSpaceKeyKind =
  | 'wardrobe'
  | 'wardrobe-item'
  | 'outfits'
  | 'capsules'
  | 'capsule'
  | 'available-items'

/** Matcher for `invalidateQueries`: every Style Space key of the given kinds. */
export function styleSpaceQueriesOf(...kinds: StyleSpaceKeyKind[]) {
  const wanted = new Set<string>(kinds)
  return (key: QueryKey): boolean =>
    Array.isArray(key)
    && key[0] === STYLE_SPACE_KEY_HEAD
    && typeof key[1] === 'string'
    && wanted.has(key[1])
}
